import React, { useEffect } from "react";
import { navigate } from "gatsby";
import { isAuthorised } from "../../services/auth";

const PrivateRoute = ({ component: Component, location, props, ...rest } ) => {
  


  useEffect(() => {
    const checkLoginStatus = () => {
      if (!isAuthorised() && location.pathname !== `/login`) {
        navigate("/login");
        return null;
      }
    };

    checkLoginStatus();
  }, [location]);

  return <Component {...rest} props={props}  />;
};

export default PrivateRoute;
